import { Separator } from '@mc/design-system'

import { ArticleItem } from 'types/data'
import Link from 'components/Link'
import Image from 'components/LegacyImage'
import { truncate, formattedDate, parseText } from '../utils'
import { trackArticleClicked } from '../events'

const IMG_WIDTH = 242
const IMG_HEIGHT = 136

export const Article = ({ article }: { article: ArticleItem }) => (
  <div key={article.title}>
    <Separator className='mc-my-3' />
    <Link
      className='d-flex justify-content-between align-items-md-center'
      href={article.linkPath}
      onClick={() => trackArticleClicked(article)}
      passHref
    >
      <>
        <div className='col-8 mc-px-0'>
          <h3 className='mc-text-h5 mc-text--bare-link'>{article.title}</h3>
          {article.subtitle && (
            <p className='mc-opacity--hinted mc-text--pre-wrap mc-my-2'>
              {truncate(parseText(article.subtitle), 178)}
            </p>
          )}
          {article.date && (
            <p className='mc-mt-2 mc-opacity--muted mc-text-x-small'>
              {formattedDate(article.date)}
            </p>
          )}
        </div>
        <div className='col-4 mc-pr-0'>
          <Image
            alt=''
            src={`${article.image}?fit=fill&fl=progressive&fm=jpg&h=${IMG_HEIGHT}&w=${IMG_WIDTH}`}
            height={IMG_HEIGHT}
            width={IMG_WIDTH}
          />
        </div>
      </>
    </Link>
  </div>
)
